import React from 'react';
import PropTypes from 'prop-types';
import ChatIcon from '@material-ui/icons/Chat';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import SettingsIcon from '@material-ui/icons/Settings';
import {
	SidebarContainer,
	SidebarIcon,
	SidebarButton,
	UnreadBadge,
} from './styles';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { Person, SignalCellularAlt, Phone } from '@material-ui/icons';
import { getWhatsappUserInfo } from 'util/isAdmin';
import { ACTIVE_CHATS_TAB, DASHBOARD_TAB, PENDING_CHATS_TAB, SETTINGS_TAB, DEPARTMENTS_TAB, PHONE_NUMBERS_TAB } from 'newComponents/ChatWhatsapp/utils/whatsappSIdebarTabs';

const Sidebar = ( { activeTab, setActiveTab } ) => {
	const IS_ADMIN_PROFILE = getWhatsappUserInfo()?.profile_type_id === 1;

	const {
		unreadActiveChats,
		unreadPendingChats
	} = useMessage();

	
	return (
		<SidebarContainer>
			<div>
				<SidebarButton
					title="Minhas conversas"
					active={activeTab === ACTIVE_CHATS_TAB}
					onClick={() => setActiveTab( ACTIVE_CHATS_TAB )}
				>
					<SidebarIcon>
						<Person />
						{unreadActiveChats > 0 && (
							<UnreadBadge>{unreadActiveChats}</UnreadBadge>
						)}
					</SidebarIcon>
				</SidebarButton>
				<SidebarButton
					title="Conversas sem atendimento"
					active={activeTab === PENDING_CHATS_TAB}
					onClick={() => setActiveTab( PENDING_CHATS_TAB )}
				>
					<SidebarIcon>
						<ChatIcon />
						{unreadPendingChats > 0 && (
							<UnreadBadge>{unreadPendingChats}</UnreadBadge>
						)}
					</SidebarIcon>
				</SidebarButton>

				{IS_ADMIN_PROFILE &&
					<SidebarButton
						title="Dashboard"
						active={activeTab === DASHBOARD_TAB}
						onClick={() => setActiveTab( DASHBOARD_TAB )}
					>
						<SidebarIcon>
							<SignalCellularAlt />

						</SidebarIcon>
					</SidebarButton>
				}
				{IS_ADMIN_PROFILE && (
					<SidebarButton
						title="Departamentos"
						active={activeTab === DEPARTMENTS_TAB}
						onClick={() => setActiveTab( DEPARTMENTS_TAB )}
					>
						<SidebarIcon>
							<AccountBalanceIcon />
						</SidebarIcon>
					</SidebarButton>
				)}
				{IS_ADMIN_PROFILE && (
					<SidebarButton
						title="Números de telefone"
						active={activeTab === PHONE_NUMBERS_TAB}
						onClick={() => setActiveTab( PHONE_NUMBERS_TAB )}
					>
						<SidebarIcon>
							<Phone />
						</SidebarIcon>
					</SidebarButton>
				)}
			</div>

			<div>
				<SidebarButton
					title="Configurações"
					active={activeTab === SETTINGS_TAB}
					onClick={() => setActiveTab( SETTINGS_TAB )}
				>
					<SidebarIcon>
						<SettingsIcon />
					</SidebarIcon>
				</SidebarButton>
			</div>

		</SidebarContainer>
	);
};

Sidebar.propTypes = {
	activeTab    : PropTypes.oneOf( [ ACTIVE_CHATS_TAB, PENDING_CHATS_TAB, DASHBOARD_TAB, SETTINGS_TAB, DEPARTMENTS_TAB, PHONE_NUMBERS_TAB ] ).isRequired,
	setActiveTab : PropTypes.func.isRequired,
};

export { Sidebar };

